import { LoginApi } from '@/helper/finger.js';
import { tagPushLogin, tagPushRegister } from '@/hook/push.js';
import { session } from '@/main.js';
import { api } from '@/facade/api.js';
import { API_ROUTE } from '@common/schema/api.js';
import { pushRoute } from '@/facade/router.js';
import { useStorage } from 'bambam-storage';
import { ref } from 'vue';

const use_register = useStorage('steam.register', false);

export const steamVerify = async (url, register = use_register.get()) => {
  const endpoint = register ? API_ROUTE.auth.steam.register_verify : API_ROUTE.auth.steam.login_verify;
  const payload = await LoginApi.call(endpoint, { url });
  session.onLogin(payload);
  if (payload) {
    if (register) {
      tagPushRegister('steam', payload);
    } else {
      tagPushLogin('steam', payload);
    }
  }
};

export const steamLogin = async (register = false, data = {}) => {
  use_register.set(register);
  const endpoint = register ? API_ROUTE.auth.steam.register_link : API_ROUTE.auth.steam.login_link;
  const payload = await api.call(endpoint, data);
  const { link } = payload;
  if (!link) return;

  const new_window = window.open(link, 'BitSkinsSteamLogin', 'height=600,width=800,top=5,left=240,dependent=yes');
  if (new_window) {
    window.handleChildCall = (href) => {
      pushRoute(`/${href.split('/').slice(3).join('/')}`);
    };
  } else {
    window.location.href = link;
  }
};

export const register_first = ref(false);
